import { PIECE_JOINTE_TYPE_LOGO } from '@/configuration/pieceJointeConf';
import { pGetAllPieceJointe } from '@/api/pieceJointes';
import get from 'lodash/get';

export async function getPJsLogoByIds(ids) {
  if (!Array.isArray(ids) || !ids.length) return [];
  const allPiece = (await pGetAllPieceJointe({
    elementsId: ids,
    placeType: PIECE_JOINTE_TYPE_LOGO,
  })).data.result.items;
  return allPiece;
}

export async function getPiecesJointeLogoConcurrents(concurrents) {
  if (!Array.isArray(concurrents) || !concurrents.length) return;

  const elementsId = [
    ...new Set(
      concurrents.flatMap((concurrent) => {
        const elements = [concurrent.id];

        const tiersMarques = concurrent.tiersMarques || [];
        if (tiersMarques.length && tiersMarques[0].marqueId) {
          elements.push(tiersMarques[0].marqueId);
        }

        return elements;
      }),
    ),
  ];

  if (!elementsId.length) return;

  const allPiece = (await pGetAllPieceJointe({ elementsId })).data.result.items;

  const trouver = id => allPiece.find(
    p => p.elementId === id && p.placeType === PIECE_JOINTE_TYPE_LOGO,
  );

  concurrents.forEach((concurrent) => {
    let piece = trouver(concurrent.id);

    if (!piece) {
      const tiersMarques = concurrent.tiersMarques || [];
      const premierMarqueId = tiersMarques.length ? tiersMarques[0].marqueId : null;

      if (premierMarqueId) {
        piece = trouver(premierMarqueId);
      }
    }

    if (!piece) return;

    concurrent.cheminMin = piece.cheminMin || piece.chemin;
    concurrent.chemin = piece.chemin;
    concurrent.urlLogo = piece.chemin;
  });
}

export default async function getPiecesJointeLogoByIds(data, field = 'id', champParent = null) {
  if (!Array.isArray(data) || !data.length) return;

  const elementsId = [
    ...new Set([
      ...data.map(i => get(i, field)),
      ...(champParent ? data.map(i => get(i, champParent)) : []),
    ].filter(Boolean)),
  ];
  if (!elementsId.length) return;

  const allPiece = (await pGetAllPieceJointe({ elementsId })).data.result.items;
  const trouver = id => allPiece.find(p => p.elementId === id && p.placeType === PIECE_JOINTE_TYPE_LOGO);

  data.forEach(m => {
    let piece = trouver(get(m, field));
    if (!piece && champParent) piece = trouver(get(m, champParent));
    if (!piece) return;
    m.cheminMin = piece.cheminMin === '' ? piece.chemin : piece.cheminMin;
    m.chemin = piece.chemin;
    m.urlLogo = piece.chemin;
  });
}
